import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import mapStateToProps from "../../store/mapStateToProps";
import mapDispatchToProps from "../../store/mapDispatchToProps";
import { Link } from 'react-router-dom';
import $ from 'jquery';
import {hit} from '../metrics';
import s from './Accreditation.module.css'
import { isReferrer } from '../helpers/getReferrer';

class Accreditation extends Component {
	componentDidMount(){
		this.props.setPageId('contact');
		setTimeout(() => {
			$('body').addClass('fadepage page-projects');
    }, 100);
    hit(window.location.pathname);
	}

	componentWillUnmount(){
		$('body').removeClass('fadepage page-projects');
	}

  render() {
    return(
      <>

        {!isReferrer() && (
          <>
            <div className={s.wrap}>
              <h1>Информация о деятельности в области информационных технологий</h1>
              <p><strong>1. Полное наименование организации:</strong> Общество с ограниченной ответственностью "Мультилайн Интернет Решения"</p>
              <p><strong>2. Адрес организации:</strong> 107061, г. Москва, Преображенская площадь, д.6, пом. XXIII, к.11</p>
              <p><strong>3. ИНН:</strong> 9718039113</p>
              <p><strong>4. Основной ОКВЭД:</strong> 62.01 — Разработка компьютерного программного обеспечения</p>
              <p><strong>5. Адрес электронной почты:</strong> amio@amio.ru</p>
              <p><strong>6. Номер телефона организации:</strong> 7(495) 921-41-70</p>
              <p><strong>7. Коды видов деятельности в области информационных технологий:</strong>
                <ul>
                  <li>
                    1.01. Проектирование, и (или) обследование, и (или) разработка, и (или) адаптация, и (или) модификация (в том числе локализация, кастомизация, доработка), и (или) обратное проектирование (реверсивный инжиниринг), и (или) модернизация, и (или) обновление, и (или) установка, и (или) интеграция, и (или) настройка, и (или) конфигурирование, и (или) внедрение, и (или) сопровождение, и (или) тестирование, и (или) испытания, и (или) техническая поддержка, и (или) эксплуатация, включая администрирование, а также оказание услуг (в том числе консультационных, услуг по обучению, экспертных услуг и иных) в указанных видах деятельности (далее - проектирование и (или) иная деятельность, а также оказание услуг), в отношении программ для электронных вычислительных машин (далее - программы для ЭВМ), и (или) баз данных (в том числе их обновлений и исправлений), и (или) визуальных пользовательских интерфейсов
                  </li>
                  <li>
                    3.01.Деятельность по созданию баз данных и информационных ресурсов (включая разработку концепций, структуры, состава баз данных), формированию и ведению баз данных (включая сбор данных из одного или более источников, а также ввод, верификацию и актуализацию данных), администрированию баз данных (включая обеспечение возможности доступа к базе данных в режиме непосредственного или телекоммуникационного доступа), поиску данных, их отбору и сортировке по запросам, предоставлению отобранных данных пользователям
                  </li>
                  <li>
                    4.01. Комплексное обслуживание ИТ-инфраструктуры, организация удаленного доступа заказчика к ИТ-инфраструктуре, включая: администрирование прав доступа, учетных записей пользователей, аппаратной платформы ИТ-инфраструктуры, баз данных, систем мониторинга, выполнение системных настроек, получение обновлений, их установка и (или) сопровождение установки; обеспечение сетевой доступности; резервное копирование; выполнение плановых и внеплановых восстановлений; осуществление миграции (переноса) данных
                  </li>
                  <li>
                    1.05.Проектирование и (или) иная деятельность, а также оказание услуг в отношении сайтов или страниц сайтов в информационно-телекоммуникационной сети, включая информационно-телекоммуникационную сеть "Интернет"
                  </li>
                  <li>
                    1.07.Проектирование и (или) иная деятельность, а также оказание услуг в отношении 2D и 3D-моделей и визуализаций (в том числе BIM-моделей), цифровых копий физического объекта или процесса
                  </li>
                </ul>
              </p>
              <p><strong>8. Информация, содержащая описание выполняемых работ и оказываемых услуг:</strong>
                <br />
                <Link to="/projects/apps/">https://www.amio.ru/projects/apps/</Link><br />
                <Link to="/accents/reality/">https://www.amio.ru/accents/reality/</Link><br />
                <Link to="/projects/web/">https://www.amio.ru/projects/web/</Link>
              </p>
              <p><strong>9. Информация о стоимости услуг:</strong> стоимость оказываемых услуг обсуждается при обращении через <span onClick={() => this.props.openPopup(true)}>форму обратной связи</span></p>
              <p><strong>10. Технологический стек компании:</strong> включает нижеследующие языки программирования, фреймворки и инструменты разработки:
              <br />
              App: React Native, Swift, Kotlin<br />
              Web: JavaScript, PHP, React, Next.js, Laravel, PostgreSQL, MySQL, Git
              </p>
            </div>
          </>
        )}
        {isReferrer() && ( //для amio-ads.ru
          <>
            <div className={s.wrap}>
              <h1>Информация о деятельности в области информационных технологий</h1>
              <p><strong>1. Полное наименование организации:</strong> Общество с ограниченной ответственностью "Амио"</p>
              <p><strong>2. Адрес организации:</strong> 107061, г Москва, вн.тер.г муниципальный округ Преображенское, пл. Преображенская, 6, помещ. 6б/1</p>
              <p><strong>3. ИНН:</strong> 7718888890</p>
              <p><strong>4. Основной ОКВЭД:</strong> 73.11</p>
              <p><strong>5. Адрес электронной почты:</strong> start@amio-ads.ru </p>
              <p><strong>6. Номер телефона организации:</strong> 7(495) 580-25-59</p>
              <p><strong>7. Коды видов деятельности в области информационных технологий:</strong>
                <ul>
                  <li>
                    12.01. Оказание услуг с использованием разработанных организацией либо лицом, входящим в одну группу лиц с данной организацией, программ для ЭВМ, баз данных (далее - собственные программы для ЭВМ, базы данных), в том числе путем предоставления удаленного доступа к программам для ЭВМ и (или) базам данных, по учету и (или) распространению рекламы и (или) рекламной информации в информационно-телекоммуникационной сети "Интернет" и (или) получению доступа к такой информации, а также оказание услуг, направленных на получение возможности распространять рекламную информацию и (или) получение доступа к такой информации, размещение и показ объявлений и (или) предложений о приобретении (реализации) товаров (работ, услуг), имущественных прав, осуществление поиска информации о потенциальных покупателях (продавцах) и (или) заключении сделок
                  </li>
                </ul>
              </p>
              <p><strong>8. Информация, содержащая описание выполняемых работ и оказываемых услуг:</strong>
                <br />
                <Link to="/accents/ccp/">https://www.amio-ads.ru/accents/ccp/</Link><br />
                <Link to="/advertising/">https://amio-ads.ru/</Link><br />
              </p>
              <p><strong>9. Информация о стоимости услуг:</strong> стоимость оказываемых услуг обсуждается при обращении через <span onClick={() => this.props.openPopup(true)}>форму обратной связи</span></p>
              <p><strong>10. Технологический стек компании:</strong> включает нижеследующие языки программирования, фреймворки и инструменты разработки:
              <br />
              JavaScript, PHP, React, Next.js, MySQL, REST API.<br />
              Данные инструменты используются для разработки и поддержки web-платформы управления рекламой и аналитикой в сети Интернет.
              </p>
            </div>
          </>
        )}
      </>
    )
  }
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Accreditation)